module.exports = __webpack_public_path__ + "static/media/rsr-logo-header.556ea3d2.svg";